import { Injectable } from '@angular/core';
import { AssociatedCostsCatalogApiItem, CatalogOption } from '../../domain/models/associated-costs-catalog.model';

/** Mismo set de colores que ya usaban los catálogos estáticos (rango de capital, socios). */
const CATALOG_COLORS = ['#A7C7E7', '#B5EAD7', '#FFF5BA', '#FFDAC1', '#E0BBE4', '#C4FAF8', '#FFD6E0'];

@Injectable({
    providedIn: 'root'
})
export class AssociatedCostsCatalogMapperService {

    /**
     * Solo el paso 1 del formulario; color asignado por índice. `label` concatena el
     * monto para mostrar, `value` (lo que se guarda/envía) es `costDescription` a secas.
     */
    mapCatalogResponse(items: AssociatedCostsCatalogApiItem[]): CatalogOption[] {
        return (items ?? [])
            .filter(item => item?.stepCost === 'FORM_ONE')
            .map((item, index) => {
                const label = item.amount > 0
                    ? `${item.costDescription} (+ S/${item.amount})`
                    : item.costDescription;

                return { value: item.costDescription, label, color: CATALOG_COLORS[index % CATALOG_COLORS.length] };
            });
    }
}
